import React from "react"
import { SelectContext } from "./Select"


// Context
interface SelectItemProps extends React.HTMLAttributes<HTMLDivElement> {
    value: string
}


export const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(
    ({ className = "", children, value }, ref) => {
        const { value: selectedValue, onValueChange, setIsOpen } = React.useContext(SelectContext)
        const isSelected = selectedValue === value

        const handleClick = (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            onValueChange?.(value);
            setIsOpen(false);
        };

        return (
            <div
                ref={ref}
                className={`relative flex w-full cursor-pointer select-none items-center px-3 py-2 text-sm outline-none hover:bg-gray-100 ${isSelected ? "bg-gray-100 font-medium" : ""
                    } ${className}`}
                onClick={handleClick}
            >
             <span className=" line-clamp-1">   {children}</span>
            </div>
        )
    }
)
SelectItem.displayName = "SelectItem"